import { Component, Input, OnDestroy } from "@angular/core";
import { IAppLink } from "./app-link/models/IAppLink";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IUser } from "../admin/users/models/IUser";
import { CurrentUserService } from "../shared/services/current-user.service";

@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnDestroy {
  @Input() title: string;
  private destroy = new Subject<any>();

  isMenuCollapsed = true;
  user: IUser;

  links: IAppLink[] = [];

  constructor(currentUserService: CurrentUserService) {
    currentUserService.currentUserData$
      .pipe(takeUntil(this.destroy))
      .subscribe((currentUser) => {
        this.user = currentUser;
        this.addLinks();
      });
  }

  ngOnDestroy() {
    this.destroy.next();
  }

  appLinkClicked() {
    this.isMenuCollapsed = true;
  }

  addLinks() {
    if (this.user !== undefined && this.user !== null && this.user.role === "User") {
      this.links = [];
      if (this.user.canSeeReportsPermission) {
        this.links.push({
          label: "Reports",
          children: [
            { relativePath: "/reports", label: "All Reports!" },
            { relativePath: "", label: null }, // hack to put in a divider
            { relativePath: "/reports/full", label: "Full Report" },
            { relativePath: "/reports/person", label: "Person Report" },
            {
              relativePath: "/reports/project/monthly",
              label: "Project Monthly YTD Report",
            },
            {
              relativePath: "/reports/project/weekly",
              label: "Project Weekly Report",
            },
            {
              relativePath: "/reports/variance",
              label: "Project Variance Report",
            },
          ],
        });
      }
      this.links.push(
        {
          label: "Time Periods",
          relativePath: "/periods",
        },
        {
          label: "My Time off",
          relativePath: "/pto",
        },
        {
          label: "Holidays",
          relativePath: "/holidays",
        }
      );
      if (this.user.specialPermission) {
        this.links.push({
          label: "Company",
          children: [{ relativePath: "/org", label: "Tree" }],
        });
      }
    }
    if (this.user !== undefined && this.user !== null && this.user.role === "Admin") {
      this.links = [
        {
          label: "Admin",
          children: [
            { relativePath: "/admin/users", label: "User Management" },
            { relativePath: "/admin/projects", label: "Project Management" },
            { relativePath: "/admin/workorders", label: "Work Order Management" },
            { relativePath: "/admin/ptoPolicies", label: "Paid Time Off Management" },
            { relativePath: "/admin/time/manage", label: "Manage Work Time" },
            { relativePath: "/admin/hangfire-redirect", label: "Hangfire Dashboard" }
          ],
        },
        {
          label: "Reports",
          children: [
            { relativePath: "/reports", label: "All Reports!" },
            { relativePath: "", label: null }, // hack to put in a divider
            { relativePath: "/reports/full", label: "Full Report" },
            { relativePath: "/reports/person", label: "Person Report" },
            {
              relativePath: "/reports/project/monthly",
              label: "Project Monthly YTD Report",
            },
            {
              relativePath: "/reports/project/weekly",
              label: "Project Weekly Report",
            },
            {
              relativePath: "/reports/variance",
              label: "Project Variance Report",
            },
          ],
        },
        {
          label: "Time Periods",
          relativePath: "/periods",
        },
        {
          label: "My Time off",
          relativePath: "/pto",
        },
        {
          label: "Holidays",
          relativePath: "/holidays",
        },
        {
          label: "Company",
          children: [{ relativePath: "/org", label: "Tree" }],
        },
      ];
    }
  }
}
